// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import { Card, Selects } from './../../components';
import Grid, { GridItem } from './../../components/layout/Grid';
import { Spoiler } from './../../components/ui';
import OrgUnitSelect from '../../components/OrgUnitSelect';
import { Filter } from '../../components/hoc';
import type { UsersFilterParams } from '../../lib/types/filters';

export type { UsersFilterParams } from '../../lib/types/filters';
const {
  Field
} = Card;
const {
  UserRoleSelect
} = Selects;
const Content = styled.div.withConfig({
  displayName: "Filter__Content",
  componentId: "sc-1v78dqe-0"
})(["padding:16px;"]);
const Buttons = styled(GridItem).withConfig({
  displayName: "Filter__Buttons",
  componentId: "sc-1v78dqe-1"
})(["margin:0 -10px;& .ant-btn{margin:0 10px;}"]);
const UserFilter = ({
  filter,
  applyFilter,
  cleanFilter
}) => <Spoiler label="Фильтр">
    <Content>
      <Grid gutter="16px">
        <Filter initialValues={filter} applyFilter={applyFilter} cleanFilter={cleanFilter}>
          {({
          values,
          changeValue,
          applyFilter,
          cleanFilter
        }) => <>
              <GridItem>
                <Field label="ФИО">
                  <Input placeholder="Введите ФИО сотрудника" value={values.search} onChange={({
                target: {
                  value
                }
              }) => changeValue('search', value)} />
                </Field>
              </GridItem>
              <GridItem>
                <Field label="Роль">
                  <UserRoleSelect value={values['role.id']} onChange={value => changeValue('role.id', value)} />
                </Field>
              </GridItem>
              <GridItem>
                <Field label="Подразделение">
                  <OrgUnitSelect value={values['employee.nodeId']} onChange={value => {
                changeValue('employee.nodeId', value);
              }} />
                </Field>
              </GridItem>
              <Buttons fullWidth>
                <Button type="primary" onClick={applyFilter}>
                  Применить
                </Button>
                <Button type="plain" onClick={cleanFilter}>
                  Очистить
                </Button>
              </Buttons>
            </>}
        </Filter>
      </Grid>
    </Content>
  </Spoiler>;
export default UserFilter;
